import { gql } from '@/__generated__';
import {
  StreamAccessQueryQuery,
  StreamAccessQueryQueryVariables,
} from '@/__generated__/graphql';
import { MonitorAccess } from '@/components/payments/monitor-access.tsx';
import { useStreamCryptoPaymentState } from '@/components/streams/toggle-paid-stream-subscription/stream-crypto-payment-var';
import { PendingStreamCryptoPaymentModal } from './pending-stream-crypto-payment-modal';

const StreamAccessQuery = gql(`
  query StreamAccessQuery($id: ID!) {
    stream(id: $id) {
      accessAllowed
    }
  }
  `);

type Props = {
  streamId: string;
  accessAllowed?: boolean;
};

export const MonitorPaidStreamAccess = ({ streamId, accessAllowed }: Props) => {
  const { initiated, invoiceUrl } = useStreamCryptoPaymentState(streamId);

  return (
    <>
      <MonitorAccess<StreamAccessQueryQuery, StreamAccessQueryQueryVariables>
        query={StreamAccessQuery}
        variables={{ id: streamId }}
        cryptoPaymentInitiated={initiated}
        accessAllowed={accessAllowed}
        isVerified={(data) => data.stream?.accessAllowed === true}
        onVerify={(paymentOption) => {
          window.mixpanel?.track('Paid Stream Unlock Verified', {
            'Stream ID': streamId,
            'Payment Option': paymentOption,
          });
        }}
      />

      {initiated && !accessAllowed ? (
        <PendingStreamCryptoPaymentModal
          streamId={streamId}
          invoiceUrl={invoiceUrl}
        />
      ) : null}
    </>
  );
};
